<template>
	<div class="report-home-main">
		<!-- Reports Home -->
		<div class="report-home">
      <router-view class="router"/>
    </div>

		<div class="version-in-report-page">
			<img :src="logo" alt="" height="20">
			<div>v{{ version }}</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */

export default {
	data: function() {
		return {
			logo: '',
			version: ''
		}
	},
	methods: {
	},
	async mounted() {
		let userDetails = await this.$apiCallV2('/Login/GetDetails');
		this.logo = userDetails['CoLogo'];

		let versions = (await this.$app.methods.getVersion()).reverse();
		this.version = versions[0]['Version'];
	}	
}
</script>

<style lang="scss">
@import '@/css/all.scss';

.report-home-main, .report-home {
	width: 100%;
	height: 100%;
}

.version-in-report-page {
	position: fixed;
	top: 10px;
	left: 10px;
	background-color: white;
	padding: 5px;
	font-size: 12px;
	border-radius: 5px;
	display: flex;
	align-items: center;

	> img {
		margin-right: 5px;
	}
}
</style>